import React, { useState } from "react";
import "./Navbar.css";
import { FaInstagram, FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      {/* Left: Logo */}
      <div className="nav-logo">
        <a href="/">
          <img src="/logo.png" alt="Cafe Logo" />
        </a>
      </div>

      {/* Center: Navigation Links */}
      <div className="nav-links">
        <a href="/">Home</a>
        <a href="/menu/set">Menu</a>
        <a href="/#about">About</a>
        <a href="/#contact">Contact Us</a>
      </div>

      {/* Right: Reservation + Instagram */}
      <div className="nav-actions">
        <Link to="/reservation" className="reservation-btn">
          Reservation
        </Link>
        <a
          href="https://www.instagram.com/turcafood/"
          target="_blank"
          rel="noreferrer"
          className="instagram-icon"
        >
          <FaInstagram />
        </a>

        {/* Mobile Hamburger */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`nav-links-mobile ${menuOpen ? "active" : ""}`}>
        <a href="/" onClick={() => setMenuOpen(false)}>Home</a>
        <a href="/menu/set" onClick={() => setMenuOpen(false)}>Menu</a>
        <a href="/#about" onClick={() => setMenuOpen(false)}>About</a>
        <a href="/#contact" onClick={() => setMenuOpen(false)}>Contact Us</a>
        <Link to="/reservation" onClick={() => setMenuOpen(false)}>Reservation</Link>
      </div>
    </nav>
  );
}
